export const receiverStatus = {
  ACCESS_DENIED: 0, // アクセス不可
  DRAFT: 2, // 下書き
  WAITING_FOR_DELIVERY: 3, // 配信中待ち
  WAITING_FOR_CONFIRMATION: 4, // 確認待ち
  SENT: 6, // 送信済み
  CONFIRMED: 7, // 確認済み
  SIGNED: 8, // 押印または入力済み
  REJECTED: 9, // 却下
  CANCEL: 10, // キャンセル
  SIGNING: 12, // 署名中
};

export const onlineContractDocumentStatus = {
  REJECTED: 3,
};

export const onlineContractStep = {
  CONFIRM_CONTRACT_CONTENT: 1,
  CREATE_CONTRACT: 2,
  REQUEST_SIGN: 3,
  CONFIRM_AND_REQUEST_STAMP: 4,
};

export const manualContractStep = {
  CREATE_CONTRACT: 1,
  UPLOAD_CONTRACT: 2,
  CONFIRM_CONTRACT: 3,
  APPROVE_CONTRACT: 4,
};

export const DOCUMENT_CONTRACT_TABS = {
  CREATE_CONTRACT: "createContract",
  UPLOAD_CONTRACT: "uploadContract",
  CONFIRM_CONTRACT: "confirmContract",
} as const;

export const signatoryType = {
  LESSOR: 1,
  AGENT: 2,
};
